import {Field, FieldMinimal} from '@docma-mm-core/field/field';
import { FieldDataTypeEnum } from '@docma-mm-core/field/field-data-type.enum';

export class LayoutField {

  constructor(init?: Partial<LayoutField> ) {
    if (init) {
      Object.assign(this, init);
      if (init.Field) {
        this.Field = new Field(init.Field);
      }
    }
  }

  Id?: number;
  LayoutId?: number;
  Field?: Field;
  Width?: number;
  SortId?: number;
  Grouping?: number;
  Sorting?: number;
  ParentFieldId?: number;
  IsDescending?: boolean;
  Index?: number;
}

export class LayoutFieldExt {

  constructor(init?: Partial<LayoutFieldExt>) {
    if (init) {
      Object.assign(this, init);
      if (init.FieldMinimal) {
        this.FieldMinimal = init.FieldMinimal;
      }
      if (init.LayoutField) {
        this.LayoutField = init.LayoutField;
      }
    }

  }

  FieldMinimal?: FieldMinimal;
  LayoutField?: LayoutField;
  IsAssigned?: boolean;
  HasPermission?: boolean;
}
